"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.putCartAction = exports.putCartItem = exports.postCart = exports.putCart = exports.getCart = exports.getCarts = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var cartsPath = root_1.ecommerceAuthorized + '/carts/';

var getCarts = function getCarts(authentication, queryParameters) {
  return common_1.get(authentication, cartsPath, queryParameters);
};

exports.getCarts = getCarts;

var getCart = function getCart(authentication, id) {
  return common_1.get(authentication, cartsPath + id);
};

exports.getCart = getCart;

var putCart = function putCart(authentication, cart) {
  return common_1.put(authentication, cartsPath + cart.id, cart);
};

exports.putCart = putCart;

var postCart = function postCart(authentication, cart) {
  return common_1.post(authentication, cartsPath, cart);
};

exports.postCart = postCart;

var putCartItem = function putCartItem(authentication, id, cartItem) {
  return common_1.put(authentication, cartsPath + id + '/item', cartItem);
};

exports.putCartItem = putCartItem;

var putCartAction = function putCartAction(authentication, id, action, data) {
  return common_1.putSub(authentication, cartsPath, id, action, data);
};

exports.putCartAction = putCartAction;